import { useUserDataContext } from 'lane-shared/hooks';
import { hasPermission } from 'lane-shared/helpers';
import { PERMISSION_KEYS } from 'constants-permissions';

export const useServiceRequestChargeOverridePermissionEnabled = (
  channelId: string
) => {
  const { user } = useUserDataContext();

  if (!user) {
    return { canEditChargeRate: false };
  }

  const canEditChargeRate =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [
        PERMISSION_KEYS.PERMISSION_ADMIN,
        PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_OVERRIDE_RATE,
      ],
      channelId
    );

  return { canEditChargeRate };
};
